export { default } from './Lazy';
